module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVBAMAAABbObilAAAAGFBMVEWZmZlHcEyZmZmZmZmYmJiampqYmJiZmZmkcU4vAAAAB3RSTlN7APl4d5+fl3OyAwAAAGlJREFUCNdjEIQDAQYxZSjTKYBBqJwRIlquwCBSXgBms5cbMAAJRrBwgQADiAQLMwLZYAmQAIgNosF8BrA8A0gdmC1QXg7SD2YDJQoEsbCR1SDpRTYTyS5kNyC5TRjJzch+EVWB+tEoAACkYSK65twH+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 3